import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchDashboardStart,
    fetchDashboardSuccess,
    fetchDashboardFail
} from '../slices/dashboardSlice';

import { getRequest } from '../../network';
import { getDashboardAnalytics } from '../apis';

function* fetchDashboardSaga(action) {
    try {
        const response = yield call(getRequest, getDashboardAnalytics, action?.payload);
        yield put(fetchDashboardSuccess(response));
    } catch (error) {
        let errorMessage = 'Something went wrong';
        if (error?.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        yield put(fetchDashboardFail(errorMessage));
    }
}

export function* watchDashboard() {
    yield takeEvery(fetchDashboardStart.type, fetchDashboardSaga);
}